import React, { useState, useEffect } from "react";

import AddList from "./AddList";
import Summary from "./Summary";
import { useSelector } from "react-redux";

const GoldRawMaterials = ({ next }) => {
  const [selectedProperties, setSelectedProperties] = useState([]);
  const [summaryValues, setSummaryValues] = useState([]);
  const currentCard = useSelector((state) => state.currentCard.currentCard);

  const handleSetProperties = (obj) => {
    const value = selectedProperties.find((item) => {
      if (item.id === obj.id) return true;
      return false;
    });
    if (value !== undefined) {
      setSelectedProperties((pre) =>
        pre.filter((item) => item.id !== value.id)
      );
    } else {
      setSelectedProperties((pre) => [...pre, obj]);
    }
  };

  const handleSetSummaryValues = (arr) => {
    setSummaryValues(arr);
  };

  const handleResetSummaryValues = () => {
    setSummaryValues([...selectedProperties]);
  };

  const handleDeleteSummaryRow = (id) => {
    setSummaryValues((pre) => [
      ...pre.map((item) => {
        if (item.id === id) {
          return selectedProperties.find((ele) => ele.id === id);
        }
        return item;
      }),
    ]);
  };

  const renderTab = () => {
    if (currentCard === 1) {
      return (
        <AddList
          selectedProperties={selectedProperties}
          handleSetProperties={handleSetProperties}
        />
      );
    } else if (currentCard === 2) {
      return (
        <Summary
          next={next}
          selectedProperties={selectedProperties}
          summaryValues={summaryValues}
          handleSetSummaryValues={handleSetSummaryValues}
          handleResetSummaryValues={handleResetSummaryValues}
          handleDeleteSummaryRow={handleDeleteSummaryRow}
        />
      );
    }
  };
  return <>{renderTab()}</>;
};

export default GoldRawMaterials;
